import React from 'react';

export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="CopyMD">
        <path
          id="Vector"
          d="M12.1894 3.81039C11.7999 1.47989 10.5504 1.15039 6.75041 1.15039C1.74941 1.15039 1.14941 1.73039 1.14941 6.75039C1.14941 10.5504 1.47991 11.7999 3.80941 12.1904C4.19991 14.5104 5.45991 14.8504 9.25041 14.8504C14.2504 14.8504 14.8504 14.2704 14.8504 9.25039C14.8504 5.45989 14.5094 4.19989 12.1894 3.81039ZM2.35041 6.75039C2.35041 2.38939 2.34941 2.35039 6.75041 2.35039C11.1504 2.35039 11.1504 2.35039 11.1504 6.75039C11.1504 11.1504 11.1504 11.1504 6.75041 11.1504C2.34941 11.1504 2.35041 11.1104 2.35041 6.75039ZM9.25041 13.6504C6.33991 13.6504 5.35041 13.6504 5.01991 12.3094H6.75041C11.7504 12.3094 12.3504 11.7304 12.3504 6.71039V4.97989C13.6704 5.31039 13.6904 6.29989 13.6904 9.21039C13.6504 13.6104 13.6104 13.6504 9.25041 13.6504Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
